/* global ga */
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import _ from 'lodash'
import SelectField from 'material-ui/SelectField'
import doctorsStore from '../stores/doctors.js'
import MenuItem from 'material-ui/MenuItem'
import { List, ListItem } from 'material-ui/List'
import { darkBlack } from 'material-ui/styles/colors'
import { Card } from 'material-ui/Card'
import { hashHistory } from 'react-router'
import AppBar from 'material-ui/AppBar';
import Cancel from 'material-ui/svg-icons/navigation/cancel';
import Search from 'material-ui/svg-icons/action/search';
import ActionHome from 'material-ui/svg-icons/action/home';
import myFunctions from '../stores/myFunctions'
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import Loading from './Loading';
import AutoComplete from 'material-ui/AutoComplete';

const home = '/m/'
var b_color = {}

class DoctorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    }

    this.handleChange = this.handleChange.bind(this)
    this.TeamChange = this.TeamChange.bind(this)
    this.pushDetail = this.pushDetail.bind(this)
    this.searchChange = this.searchChange.bind(this)
    this.home = this.home.bind(this)
    this.clearInput = this.clearInput.bind(this)
    this.goBack = this.goBack.bind(this)
    // this.onError = this.onError.bind(this)
  }

  goBack() {
    // location.href = '/m/'
    history.back()
  }

  handleChange(e, idx, val) {
    //科別
    doctorsStore.setKeyword('');
    doctorsStore.setHdept(val)
  }

  TeamChange(e, idx, val) {
    //團隊
    doctorsStore.setKeyword('');
    doctorsStore.setTeam(val)
  }

  searchChange(event, value) {
    //醫師搜尋
    doctorsStore.setSearch(event);
  }

  pushDetail(item) {
    return () => {
      doctorsStore.setDocDetail(item)
      doctorsStore.DocEmpNo = item.EmpNo
      const path = `detail?n=${doctorsStore.DocDetail.EmpNo}`
      ga('send', 'event', `醫師查詢:"醫師列表"頁面中按下醫師`, `${doctorsStore.DocDetail.NameCh}(${doctorsStore.DocDetail.EmpNo})`);
      window.scrollTo(0, 0)
      hashHistory.push(path)
    }
  }

  clearInput() {
    doctorsStore.setSearch('')
  }

  componentWillMount() {
    doctorsStore.setLoadData()
    doctorsStore.pathname = this.props.location.pathname
  }

  home() {
    location.href = `${home}`
  }

  // onError(event) {
  //   try{
  //     // console.log(event.target.src);
  //     event.target.src=`assets/dr/defaultd.jpg?${new Date().getTime()}`
  //   }catch(err){
  //     console.log(err);
  //   }
  // }

  render() {
    let strUrl = location.search;
    let getPara, ParaVal;
    let aryPara = [];

    if (strUrl.indexOf("?") != -1) {
      let getSearch = strUrl.split("?");
      getPara = getSearch[1].split("&");
      for (let i = 0; i < getPara.length; i++) {
        ParaVal = getPara[i].split("=");
        aryPara.push(ParaVal[0]);
        aryPara[ParaVal[0]] = ParaVal[1];
      }
    }

    if (doctorsStore.data !== null) {
      return (
        <div style={{ boxShadow: '0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)' }}>
          {
            aryPara.app === 'true' ? null :
              <AppBar
                title={<div>醫師查詢
            <span style={{ fontSize: '11px' }}>{myFunctions.version}
                  </span>
                </div>
                }
                style={{ backgroundColor: 'white', textAlign: 'center', height: '44px' }}
                titleStyle={{ color: 'black', height: '44px', fontWeight: '500', fontSize: '17px', lineHeight: '44px', weight: '46%', textAlign: 'center' }}
                iconElementLeft={<ChevronLeft />}
                onLeftIconButtonTouchTap={this.goBack}
                iconElementRight={<ActionHome onClick={this.home} />}
              />
          }
          <div style={{ backgroundColor: '', padding: '6px 15px 0px 15px', minHeight: '100vh' }}>
            <Card>
              <Search style={{ margin: '-10px 2px' }} />
              <AutoComplete
                id="input"
                hintText={<div style={{ color: 'rgba(0, 0, 0, 0.1)' }}>醫生中英文姓名查詢</div>}
                filter={AutoComplete.fuzzyFilter}
                dataSource={_.map(doctorsStore.totalSearch, (data) => { return data })}
                maxSearchResults={60}
                menuStyle={{ maxHeight: "300px", overflowY: 'auto' }}
                searchText={doctorsStore.keyword}
                onUpdateInput={this.searchChange}
                style={{ width: '80%' }}
                textFieldStyle={{ width: '100%' }}
              />
              <Cancel style={{ margin: '-10px 2px' }} onClick={this.clearInput} />
            </Card>

            <Card style={{ marginTop: '6px', height: '50px' }}>
              <div style={{ backgroundColor: '' }}>
                <SelectField
                  floatingLabelText="科別"
                  value={doctorsStore.hdept}
                  hintText={<div style={{ color: 'rgba(0, 0, 0, 0.1)' }}>科別</div>}
                  style={{ width: '90%', paddingLeft: '5px', height: '52px', display: '' }}
                  onChange={this.handleChange}
                  menuStyle={{ marginTop: '1px' }}
                  labelStyle={{ top: '0px' }}
                  floatingLabelStyle={{ top: '20px' }}
                >
                  {
                    _.map(doctorsStore.hdepts, (item, key) => {
                      return (
                        <MenuItem key={key} value={item} primaryText={item} />
                      )
                    })
                  }
                </SelectField>
              </div>
            </Card>

            <Card style={{ marginTop: '6px', height: '50px' }}>
              <div style={{ backgroundColor: '' }}>
                <SelectField
                  floatingLabelText="團隊"
                  value={doctorsStore.team}
                  style={{ width: '90%', paddingLeft: '5px', height: '52px', display: '' }}
                  onChange={this.TeamChange}
                  menuStyle={{ marginTop: '1px' }}
                  labelStyle={{ top: '0px' }}
                  floatingLabelStyle={{ top: '20px' }}
                >
                  {
                    _.map(doctorsStore.teams, (item, key) => {
                      return (
                        <MenuItem key={key} value={item} primaryText={item} />
                      )
                    })
                  }
                </SelectField>
              </div>
            </Card>

            <List>
              {
                _.map(doctorsStore.viewData, (item, key) => {
                  if (parseInt(key, 10) % 2 === 1) {
                    b_color = { backgroundColor: "#F9F9F9" }
                  } else {
                    b_color = { backgroundColor: "#FFF" }
                  }
                  var avator_url = `https://patient.kfsyscc.org/images/doctors/${item.EmpNo}.jpg?${new Date().getTime()}`
                  return (
                    <ListItem
                      style={b_color}
                      key={key}
                      onTouchTap={this.pushDetail(item)}
                      innerDivStyle={{ paddingLeft: 100 }}
                      leftAvatar={
                        <img
                          role="presentation"
                          src={avator_url}
                          onError={(e) => { e.target.src = `https://patient.kfsyscc.org/images/doctors/default.jpg?${new Date().getTime()}` }}
                          style={{ height: '70px', borderRadius: '5px', width: '46.6625px' }}
                        />
                      }
                      primaryText={`${item.NameCh + ' 醫師'}`}
                      secondaryText={
                        <p style={{ height: 50 }}>
                          <span style={{ color: darkBlack }}>{item.NameEn}</span><br />
                          {item.HdeptName}
                        </p>
                      }
                      secondaryTextLines={2}
                    />
                  )
                })
              }
            </List>
          </div>
        </div>
      )
    } else {
      return (<Loading />)
    }
  }
}

export default observer(DoctorList)



// WEBPACK FOOTER //
// ./src/components/DocList.js